/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import * as API from "../../http/api";
import * as Modals from ".";
import { useHistory } from "react-router-dom";
import { openlightbox, closelightbox } from "../../util/Functions";
import { Grid, TextField, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton, MenuItem, Typography } from "@mui/material";
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";

const SpaceCancel = (props) => {
  const [zPos, setZPos] = useState(45);
  const [form, setForm] = useState({ motivo: "", comentarios: ""});
  const [disabled, setDisabled] = useState(true);
  const [content, setContent] = useState({});
  const history = useHistory();
  useEffect(() => {
    setContent(props.content);
  }, []);

  const changeValue = (type, name, e) => {
    let c = form;
    if (type == "date") {
      c[name] = new Date(e).toJSON().substr(0, 10);
    } else {
      c[name] = e.target.value;
    }

    if (c.comentarios && c.motivo) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
    setForm(JSON.parse(JSON.stringify(c)));
  };

  const cancelar = async () => {
    props.changeLoader(true);
		setZPos(-1)

    let cats = props.content.catalog;
    let motivo = "";
    for (let i = 0; i < cats.length; i++) {
      if (form.motivo == cats[i]["k"]) {
        motivo = cats[i]["v"];
        break;
      }
    }
    let data = {
      space: {
        uuid: props.content.spaceUuid,
        owner: {
          application_uuid: "albo.os",
          entity_uuid: props.content.customerUuid,
        },
      },
      customerUuid: props.content.customerUuid,
      reason: form.motivo,
      extra: {
        comment: form.comentarios,
        motivo: motivo,
      },
    };

    let updateInfo = await API.service( "cancelAccount", data, props.pos, props.changeAlert, props.changeLoader, history);
    props.changeLoader(false);
		setZPos(45)

    if (updateInfo.status == 200) {
      if (updateInfo.data.data.response == "OK") {
        if (updateInfo.data.data.content) {
          if (updateInfo.data.data.content.type == "2FA" || updateInfo.data.data.content.type == "1FA") {
            let factors = localStorage.factors ? JSON.parse(localStorage.factors) : {};
            factors[content["customer_uuid"]] = updateInfo.data.data.content.uuid_factor;
            localStorage.factors = JSON.stringify(factors);
          }
          const as = (
            <Modals.Factor
              intent="openModalCancelAccount"
              contentModal={updateInfo.data.data.content}
              pos={props.pos}
              changeAlert={props.changeAlert}
              changeLoader={props.changeLoader}
              history={history}
              key="factor"
            />
          );
          openlightbox(as);
        } else {
          props.changeAlert(true, "success", "La cuenta se canceló correctamente");
          await props.changeReload();
          closelightbox();
          props.setRadioData(null);
          props.changeLoader(true);
					setZPos(-1)
          let reqSpaces = props.content.customerUuid;
          let getSpaces = await API.service( "cuentas", reqSpaces, props.pos, props.changeAlert, props.changeLoader, history );
          if (getSpaces.data.data.response == "OK") {
            props.changeWidgets(getSpaces.data.data.widget);
          }
        }
        props.changeLoader(false);
				setZPos(45)
      } else {
      }
    } else {
    }
  };

  return (
		<Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
			<ModalStyle property={String(disabled)}>
				<DialogTitle style={{marginBottom: "0"}} >
					Cancelar Cuenta
					<IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
				</DialogTitle>

				<DialogContent>
					<Grid container spacing={2} sx={{ marginTop: "10px" }} >
						<Grid item xs={12} >
						  Una vez canceladas el cliente no podrá realizar operaciones con las
        			siguientes cuentas (Cancelación total):       
							<hr style={{margin: "6px 0 2px 0"}}/>
						</Grid>

						<Grid item xs={12}>							
							{props.content && props.content.account_number ? `${props.content.account_number} (No. De cuenta)` : ""}
							<hr style={{margin: "14px 0"}}/>
						</Grid>
						{props.content?.cards?.length > 0 && 
							<><Grid item xs={12} sx={{paddingTop: "4px !important"}}>							
									{props.content?.cards?.map((item, index) => {
										return <Typography fontFamily="Muli,sans-serif" lineHeight={2.2} fontSize="0.875rem" key={index}>{`Tarjeta ${item}`}</Typography>
									})}
								</Grid>
								<Grid item xs={12} sx={{paddingTop: "4px !important"}}><hr style={{margin: "6px 0 12px 0"}}/></Grid>
							</>
						}
						
						<Grid item xs={6}>
							<TextField  
								label="Motivo de Cancelación" value={form["motivo"]} onChange={changeValue.bind(this, "select", "motivo")} select size="small" fullWidth >
									<MenuItem value={""}>Seleccione</MenuItem>
									{props.content?.catalog?.map((item, index) => (
										<MenuItem key={`option-${index}`} value={item.k}>{item.v}</MenuItem>
									))}
							</TextField>              
						</Grid> 
						<Grid item xs={6}>
							<TextField  
								label="Comentarios" value={form["comentarios"]}  onChange={changeValue.bind(this, "text", "comentarios")} size="small" fullWidth />
						</Grid>         
					</Grid>
				</DialogContent>

				<DialogActions>
					<Button id='buttonCancel' variant="outlined" onClick={closelightbox} >Cancelar</Button>
					<Button disabled={disabled} variant="contained" onClick={cancelar.bind(this)} >Aceptar</Button>
				</DialogActions>
			</ModalStyle>
		</Dialog>
  );
};

export default SpaceCancel;
